export function fixResources(template: string) {
  return (
    template
      // Replace relative urls
      .replace(/src="images\//g, 'src="/images/email/')
      // Replace cid paths
      .replace(/cid:/g, "/images/email/")
  );
}
